import { Combobox } from '@headlessui/react';
import { DefaultItemStyle } from './DefaultItemStyle';
import { Item, MultiSelectProps } from './multi-select';

export type OptionProps<T extends Item> = Pick<
  MultiSelectProps<T>,
  'mode' | 'itemDisplay'
> & { option: T };

export const Option = <T extends Item>({
  option,
  mode,
  itemDisplay: CustomItem,
}: OptionProps<T>) => {
  return (
    <Combobox.Option value={option.value} disabled={option.disabled}>
      {({ active, selected }: { active: boolean; selected: boolean }) => {
        return CustomItem ? (
          <CustomItem active={active} selected={selected} item={option} />
        ) : (
          <DefaultItemStyle
            option={option}
            active={active}
            selected={selected}
            mode={mode}
          />
        );
      }}
    </Combobox.Option>
  );
};
